export default {
    title: 'Interview Satisfaction Questionnaire',
    abnormal_404: 'Oops, the page you are looking for is missing...',
    abnormal_404_sub: 'Please check that URL is correct',
    submit: 'Submit',
    requiredError: 'This is a required question',
    reasonRequiredError: '请输入内容',
    multiSelect: ' (Multi select)',
    submitted: 'You have already submitted this questionnaire',
    submittedTime: 'Submitted at: {time}',
    expired: 'Questionnaire has expired',
    success: 'Thank you for your feedback',
    pleaseEnter: 'Please enter',
    pleaseSupplementExplanation: 'Please supplement the explanation',

    // 请求失败抛出错误
    MessageNetworkError: 'Network error. Please refresh the page or try again later.',
    MessageHttpError: 'Something went wrong. Please try again later.',
    MessageNetworkDisconnected: 'Network disconnected. Check your network connection.'
};
